<div class="row col-12 p-0 m-0 main-page-section ">

  <div class="col-12 p-0 ">

    <div class="overview-image-container">
      <img class="main-image" src="/assets/images/overview-main-image.png" alt="overview main image" loading="lazy" />
      <div class="top-left">
        <span>Lets start building </span>
        <span><br> amazing workspaces</span>
        <span class="font-bold">
          <br>together</span>
      </div>
    </div>


    <div class="div-height">
      <label class="overview-label mt-5 mb-3">Overview</label>
      <div class="row row-padding mask-class">
        <div class="p-0 col-4-employees mask pointer-link" routerLink="/employees/employees-list">
          <div class="p-4">
            <span class="main-text">Employees Enrolled</span>
            <div class="pt-4 number-text">{{overviewData?.employeeEnrolled}}</div>
            <div class="sub-text pt-1">{{overviewData?.employeeRegisteredForMonth}} new registrations this month</div>
          </div>

        </div>
        <div class="p-0 col-4-employees-checked-in mask pointer-link" (click)="navigateToReportsWithFilter($event)">
          <div class="p-4">
            <span class="main-text">Employees
              <br>checked-in today</span>
            <div class="pt-2 number-text">{{overviewData?.employeeCheckInForDay}}</div>
          </div>

        </div>
        <div class="p-0 col-4-meetings mask pointer-link" routerLink="/meeting/meetingroom-list">
          <div class=" p-4">
            <span class="main-text">Meetings booked
              for the day</span>
            <div class="pt-2 number-text">{{overviewData?.meetingsBookedForDay}}</div>
            <div class="sub-text pt-1">for {{overviewData?.meetingsBookedForDayDuration}} hours</div>
          </div>

        </div>
      </div>


      <div style="
                  margin-bottom: 61px;">
        <div class="row mask-credits row-padding col-credits pointer-link" routerLink="/credits">
          <div class="pl-0 pr-0 pt-5 main-text-credits col-width ">
            Credit point
            <br>balance
          </div>
          <div class="line"></div>

          <div class="pl-5 pr-0 flex-column col-width ">
            <div class="complimentary-points">
              Complimentary points used
            </div>
            <div class="pt-2"><span class="number-font">{{overviewData?.creditPointsUsed}}</span><span
                class="denom-number-font">/{{overviewData?.creditPointsAllocated}}</span></div>
            <div class="sub-text-credits pt-1 ">Coins will expire in {{overviewData?.creditPointsValidityInDays}} days
            </div>
          </div>
          <div class="pl-5 pr-0 flex-column main-text col-width ">
            <div class="complimentary-points pl-2">
              Purchased points used
            </div>
            <div class="pt-2 pl-2"><span class="number-font">{{overviewData?.purchasePointsUsed}}</span><span
                class="denom-number-font">/{{overviewData?.purchasePointsAllocated}}</span></div>
          </div>

        </div>
      </div>


    </div>

  </div>


</div>
<!-- <div> -->
